exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width:767px){.p-x-n[data-v-71bfe44c]{padding:0}}", ""]);

// exports
